import {GRANITE_1} from '@gaia/colors';
import GaiaIcon from '@gaia/icons/GaiaIcon';
import {ampli} from '@gaia/utils/gaia/trackAnalytics';
import {MapboxControlButton, MapboxControlGroup} from '@gaia/utils/mapbox/MapboxControl';
import SubscriptionTooltip from '@map/SubscriptionTooltip';
import mapboxgl from 'mapbox-gl';
import {useMemo} from 'react';

interface WrappedGeolocateControl extends mapboxgl.GeolocateControl {
    onAdd(map?: mapboxgl.Map): HTMLElement;
}

export function GeolocateControl({map}: {map: mapboxgl.Map | undefined}) {
    // This is a hack to use GeolocateControl's functionality without displaying it on the map.
    // We're simply throwing away the DOM element returned by the onAdd method.
    // https://github.com/mapbox/mapbox-gl-js/issues/3685
    const geolocate = useMemo(() => {
        const control = new mapboxgl.GeolocateControl({
            positionOptions: {
                enableHighAccuracy: true,
            },
            showUserLocation: false,
        });
        if (map) {
            (control as WrappedGeolocateControl).onAdd(map);
        }
        return control;
    }, [map]);

    return (
        <MapboxControlGroup>
            <MapboxControlButton
                aria-label='Find my location'
                onClick={() => {
                    if (!map) return;
                    ampli.pressLocateButton({category: 'map2'});
                    geolocate.trigger();
                }}
            >
                <SubscriptionTooltip
                    enterDelay={500}
                    placement='right'
                    title='Find My Location'
                    subscription={undefined}
                >
                    <GaiaIcon
                        name='my-location'
                        style={{color: GRANITE_1, height: 24, width: 24}}
                    />
                </SubscriptionTooltip>
            </MapboxControlButton>
        </MapboxControlGroup>
    );
}
